import React, { useState, useCallback, useRef, useEffect } from 'react';

const EmailModal = React.memo(({ modalRef, onSendOTP, onClose, isLoading }) => {
  const [mobile, setMobile] = useState('');
  const inputRef = useRef(null);

  useEffect(() => {
    const modalElement = modalRef.current;
    
    const handleModalShown = () => {
      if (inputRef.current) {
        inputRef.current.focus();
      }
    };

    if (modalElement) {
      modalElement.addEventListener('shown.bs.modal', handleModalShown);
      
      return () => {
        modalElement.removeEventListener('shown.bs.modal', handleModalShown);
      };
    }
  }, [modalRef]);

  const handleSubmit = useCallback((e) => {
    e.preventDefault();
    if (mobile.length == 10) {
      onSendOTP(mobile);
      setMobile("")
    }
  }, [mobile, onSendOTP]);

  const handleInputFocus = useCallback(() => {
    setTimeout(() => {
      if (inputRef.current) {
        inputRef.current.scrollIntoView({ 
          behavior: 'smooth', 
          block: 'center',
          inline: 'nearest'
        });
      }
    }, 300);
  }, []);

  return (
    <div 
      className="modal fade portfolio-modals-main" 
      ref={modalRef}
      tabIndex="-1"
      aria-labelledby="emailModalLabel"
      aria-hidden="true"      
    >
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-body">
            <button 
              type="button" 
              className="btn-close" 
              onClick={onClose}
              aria-label="Close"
              disabled={isLoading}
            />
            <form onSubmit={handleSubmit} className='portfolio-modals'>
              <h2>Start your journey with us!</h2>
              <p className='pt-3 mb-0 mb-lg-2'>
                Enter your  mobile number to access various job opening and get hired in your dream company
              </p>
              {/* <small className='py-2 py-lg-4'>*Only valid company domains are allowed*</small> */}
              <input 
                ref={inputRef}
                type='mobile' 
                placeholder='Mobile Number' 
                className='my-3 my-lg-4'
                value={mobile}
                onChange={(e) => setMobile(e.target.value)}
                onFocus={handleInputFocus}
                required
                disabled={isLoading}
                autoComplete="mobile"
              />
              <button 
                type="submit"
                className='default-btn blue-bg mb-5'
                disabled={isLoading || mobile.length !== 10}
              >
                {isLoading ? 'Sending...' : 'Send OTP'}
              </button>
              <h6>
                By creating an account or signing in, you understand and agree to our Terms and Conditions of services. 
                You also consent to our Privacy policies.
              </h6>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
});

export default EmailModal;
